import { faAngleDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import React from 'react';
import { ButtonGroup, Dropdown } from 'react-bootstrap';

export interface FilterMenu {
  label: string;
  items: FilterMenuItem[];
}

export interface FilterMenuItem {
  label: string;
  value?: string;
  onClick?: () => void;
  children?: FilterMenuItem[];
}

interface FilterButtonGroupProps {
  menus: FilterMenu[];
}

const RecursiveDropdown = ({ items }: { items: FilterMenuItem[] }) => {
  return (
    <>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {item.children && item.children.length > 0 ? (
            <Dropdown drop="end" className="w-100 position-relative">
              <Dropdown.Toggle as="div" className="dropdown-item d-flex justify-content-between align-items-center w-100">
                <span onClick={item.onClick}>{item.label}</span>
                <FontAwesomeIcon icon={faChevronRight} />
              </Dropdown.Toggle>
              <Dropdown.Menu className="position-absolute start-100 top-0">
                <RecursiveDropdown items={item.children} />
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <Dropdown.Item onClick={item.onClick}>{item.label}</Dropdown.Item>
          )}
        </React.Fragment>
      ))}
    </>
  );
};


const FilterButtonGroup = ({ menus }: FilterButtonGroupProps) => {
  return (
    <ButtonGroup className="position-static">
      {menus.map((menu, menuIndex) => (
        <Dropdown key={menuIndex} as={ButtonGroup} className="position-static">
          <Dropdown.Toggle
            variant="phoenix-secondary"
            className="px-7 flex-shrink-0 dropdown-caret-none"
          >
            {menu.label}
            <FontAwesomeIcon icon={faAngleDown} className="ms-2" transform="down-2" />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <RecursiveDropdown items={menu.items} />
          </Dropdown.Menu>
        </Dropdown>
      ))}
    </ButtonGroup>
  );
};

export default FilterButtonGroup;
